export default __webpack_public_path__ + "static/media/5.6bdb6de7.jpg";